import { browserScripts } from '@gousto-internal/storage-consent-web-package'

const hasConsentForDDTracking = browserScripts.hasConsent('Datadog')

export const commonConfig = {
  site: 'datadoghq.eu',
  sessionSampleRate: 100,
  service: 'help-centre-webclient',
  env: process.env.REACT_APP_ENV,
  silentMultipleInit: true,
  trackingConsent: hasConsentForDDTracking ? 'granted' : 'not-granted',
}

export const browserLogsConfig = {
  ...commonConfig,
  clientToken: process.env.REACT_APP_DATADOG_BROWSER_LOGS_TOKEN,
  forwardErrorsToLogs: true,
}

export const RUMSDKConfig = {
  ...commonConfig,
  applicationId: process.env.REACT_APP_DATADOG_RUM_SDK_APP_ID,
  clientToken: process.env.REACT_APP_DATADOG_RUM_SDK_TOKEN,
  trackUserInteractions: false,
  defaultPrivacyLevel: 'mask-user-input',
}
